const e = {
  getV1ProfilesOwnerid: {
    schema: {
      method: "get",
      url: "/v1/profiles/{ownerId}"
    }
  },
  getV1Profiles: {
    schema: {
      method: "get",
      url: "/v1/profiles"
    }
  }
};
export {
  e as v1Service
};
